import { CommerceShipConnectorsActionTypes } from './constants';

export const INIT_STATE = {
    error: null,
    creatingShopifyIntegrationAndStartingOAuth: false,
    loading: false
};

type CommerceShipConnectorsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    error?: null,
    creatingShopifyIntegrationAndStartingOAuth?: boolean,
    loading?: boolean,
};

const CommerceShipConnectors = (state: State = INIT_STATE, action: CommerceShipConnectorsAction): any => {
    switch (action.type) {
        case CommerceShipConnectorsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST: {
                    return { ...state, creatingShopifyIntegrationAndStartingOAuth: false, loading: false};
                }
                default:
                    return { ...state, creatingShopifyIntegrationAndStartingOAuth: false, loading: false};
            }

        case CommerceShipConnectorsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST: {
                    return { ...state, creatingShopifyIntegrationAndStartingOAuth: false, error: action.payload.error, loading: false};
                }
                default:
                    return { ...state };
            }

        case CommerceShipConnectorsActionTypes.CREATE_SHOPIFY_INTEGRATION_AND_START_OAUTH_REQUEST:
            return { ...state, creatingShopifyIntegrationAndStartingOAuth: true, loading: true };
        default:
            return { ...state };
    }
};

export default CommerceShipConnectors;
